import React, { Component } from 'react';
import { connect } from 'react-redux';
import { breadcrumbs } from '../../../../actions/appActions';
import { push } from 'react-router-redux';
import { OfficialsActive } from '../../components/grids/OfficialGrid'; 
import { isInternal } from '../../CroUtils';
import { getFunctionaryNoticeTypes } from '../../CroActions';

const onRowClick = (push, url) => ({ id }) => push(`${url}/funkcionari/form/${id}`);

class OfficialsAll extends Component {
  state = {
    loading: false,
    functionaryNoticeTypes: [],
  };
  
  async componentWillMount() {
    const { auth, dispatch } = this.props;
    if (isInternal(auth)) {
      this.setState({ loading: true });
      const functionaryNoticeTypes = await getFunctionaryNoticeTypes(dispatch);
      this.setState({ functionaryNoticeTypes: functionaryNoticeTypes.items, loading: false });
    }
    this.props.breadcrumbs([{ label: 'Funkcionáři' }, { label: 'Bez přihlašovacích údajů' }]);
  }

  onCreateAppeal = (noticeTypeId, selected) => {  
    const { auth } = this.props;
    if(selected.length === 0) return;

    this.props.push((selected.length === 1) ?
      { pathname: `${auth.startUrl}/funkcionari/${selected[0]}/vyzva`, state: { noticeTypeId } } :
      { pathname: `${auth.startUrl}/funkcionari/hromadna-vyzva`,
        state: {
          officialsIds: selected,
          noticeTypeId: noticeTypeId
      }
    });
  }

  render() { 
    const { push, auth } = this.props;
    return (
      <OfficialsActive 
        gridName='officialsGrid_nocreds'
        url={`${auth.startUrl}/api/funkcionari/bez-udaju`}      
        onRowClick={onRowClick(push, auth.startUrl)} 
        moreCheckboxFns={isInternal(auth)}
        moreCheckboxFnsItems={this.state.functionaryNoticeTypes.map((type) => ({ label: type.name, value: type.id, onClick: (selected) => { this.onCreateAppeal(type.id, selected) } })) }
        fnText={"Zaslat výzvu"}
        allowCheck={isInternal(auth)}
      />
    )
  }

}

export default connect(null, { breadcrumbs, push })(OfficialsAll);
